var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-box"},[_c('Editor',{attrs:{"init":_vm.init,"disabled":_vm.disabled},model:{value:(_vm.contentValue),callback:function ($$v) {_vm.contentValue=$$v},expression:"contentValue"}}),(_vm.isShade)?_c('div',{staticClass:"shade"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }